"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _toConsumableArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  position: absolute;\n  z-index: ", ";\n  ", ";\n  ", ";\n  left: ", "px;\n  background-color: ", ";\n  border-radius: 4px;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,\n    rgba(0, 0, 0, 0.08) 0px 4px 8px, rgba(0, 0, 0, 0.08) 0px 2px 4px;\n  opacity: 0;\n  transform: scale(0.95);\n  transition: opacity 150ms cubic-bezier(0.175, 0.885, 0.32, 1.275),\n    transform 150ms cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transition-delay: 150ms;\n  line-height: 0;\n  box-sizing: border-box;\n  pointer-events: none;\n  white-space: nowrap;\n  width: 300px;\n  max-height: 224px;\n  overflow: hidden;\n  overflow-y: auto;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  hr {\n    border: 0;\n    height: 0;\n    border-top: 1px solid ", ";\n  }\n\n  ", ";\n\n  @media print {\n    display: none;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  font-weight: 500;\n  font-size: 14px;\n  height: 36px;\n  padding: 0 16px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  text-align: left;\n  height: 100%;\n  padding: 8px 0;\n  margin: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 36px;\n  width: 100%;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var capitalize_1 = __importDefault(require("lodash/capitalize"));

var react_portal_1 = require("react-portal");

var prosemirror_utils_1 = require("prosemirror-utils");

var styled_components_1 = __importDefault(require("styled-components"));

var types_1 = require("../types");

var BlockMenuItem_1 = __importDefault(require("./BlockMenuItem"));

var Input_1 = __importDefault(require("./Input"));

var VisuallyHidden_1 = __importDefault(require("./VisuallyHidden"));

var getDataTransferFiles_1 = __importDefault(require("../lib/getDataTransferFiles"));

var insertFiles_1 = __importDefault(require("../commands/insertFiles"));

var block_1 = __importDefault(require("../menus/block"));

var SSR = typeof window === "undefined";

var BlockMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(BlockMenu, _React$Component);

  var _super = _createSuper(BlockMenu);

  function BlockMenu() {
    var _this;

    _classCallCheck(this, BlockMenu);

    _this = _super.apply(this, arguments);
    _this.menuRef = React.createRef();
    _this.inputRef = React.createRef();
    _this.state = {
      left: -1000,
      top: undefined,
      bottom: undefined,
      isAbove: false,
      selectedIndex: 0,
      insertItem: undefined
    };

    _this.handleKeyDown = function (event) {
      if (!_this.props.isActive) return;

      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        var item = _this.filtered[_this.state.selectedIndex];

        if (item) {
          _this.insertItem(item);
        } else {
          _this.props.onClose();
        }
      }

      if (event.key === "ArrowUp" || event.ctrlKey && event.key === "p") {
        event.preventDefault();
        event.stopPropagation();

        if (_this.filtered.length) {
          var prevIndex = _this.state.selectedIndex - 1;
          var prev = _this.filtered[prevIndex];

          _this.setState({
            selectedIndex: Math.max(0, prev && prev.name === "separator" ? prevIndex - 1 : prevIndex)
          });
        } else {
          _this.close();
        }
      }

      if (event.key === "ArrowDown" || event.key === "Tab" || event.ctrlKey && event.key === "n") {
        event.preventDefault();
        event.stopPropagation();

        if (_this.filtered.length) {
          var total = _this.filtered.length - 1;
          var nextIndex = _this.state.selectedIndex + 1;
          var next = _this.filtered[nextIndex];

          _this.setState({
            selectedIndex: Math.min(next && next.name === "separator" ? nextIndex + 1 : nextIndex, total)
          });
        } else {
          _this.close();
        }
      }

      if (event.key === "Escape") {
        _this.close();
      }
    };

    _this.insertItem = function (item) {
      switch (item.name) {
        case "image":
          return _this.triggerImagePick();

        case "embed":
          return _this.triggerLinkInput(item);

        case "link":
          {
            _this.clearSearch();

            _this.props.onClose();

            _this.props.onLinkToolbarOpen();

            return;
          }

        default:
          _this.insertBlock(item);

      }
    };

    _this.close = function () {
      _this.props.onClose();

      _this.props.view.focus();
    };

    _this.handleLinkInputKeydown = function (event) {
      if (!_this.props.isActive) return;
      if (!_this.state.insertItem) return;

      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        var href = event.currentTarget.value;

        var matches = _this.state.insertItem.matcher(href);

        if (!matches && _this.props.onShowToast) {
          _this.props.onShowToast(_this.props.dictionary.embedInvalidLink, types_1.ToastType.Error);

          return;
        }

        _this.insertBlock({
          name: "embed",
          attrs: {
            href: href,
            component: _this.state.insertItem.component,
            matches: matches
          }
        });
      }

      if (event.key === "Escape") {
        _this.props.onClose();

        _this.props.view.focus();
      }
    };

    _this.handleLinkInputPaste = function (event) {
      if (!_this.props.isActive) return;
      if (!_this.state.insertItem) return;
      var href = event.clipboardData.getData("text/plain");

      var matches = _this.state.insertItem.matcher(href);

      if (matches) {
        event.preventDefault();
        event.stopPropagation();

        _this.insertBlock({
          name: "embed",
          attrs: {
            href: href,
            component: _this.state.insertItem.component,
            matches: matches
          }
        });
      }
    };

    _this.triggerImagePick = function () {
      if (_this.inputRef.current) {
        _this.inputRef.current.click();
      }
    };

    _this.triggerLinkInput = function (item) {
      _this.setState({
        insertItem: item
      });
    };

    _this.handleImagePicked = function (event) {
      var files = getDataTransferFiles_1.default(event);
      var _this$props = _this.props,
          view = _this$props.view,
          uploadImage = _this$props.uploadImage,
          onImageUploadStart = _this$props.onImageUploadStart,
          onImageUploadStop = _this$props.onImageUploadStop,
          onShowToast = _this$props.onShowToast;
      var state = view.state,
          dispatch = view.dispatch;
      var parent = prosemirror_utils_1.findParentNode(function (node) {
        return !!node;
      })(state.selection);

      if (parent) {
        dispatch(state.tr.insertText("", parent.pos, parent.pos + parent.node.textContent.length + 1));
        insertFiles_1.default(view, event, parent.pos, files, {
          uploadImage: uploadImage,
          onImageUploadStart: onImageUploadStart,
          onImageUploadStop: onImageUploadStop,
          onShowToast: onShowToast,
          dictionary: _this.props.dictionary
        });
      }

      if (_this.inputRef.current) {
        _this.inputRef.current.value = "";
      }

      _this.props.onClose();
    };

    return _this;
  }

  _createClass(BlockMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!SSR) {
        window.addEventListener("keydown", this.handleKeyDown);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.search !== this.props.search || nextProps.isActive !== this.props.isActive || nextState !== this.state;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isActive && this.props.isActive) {
        var position = this.calculatePosition(this.props);
        this.setState(Object.assign({
          insertItem: undefined,
          selectedIndex: 0
        }, position));
      } else if (prevProps.search !== this.props.search) {
        this.setState({
          selectedIndex: 0
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!SSR) {
        window.removeEventListener("keydown", this.handleKeyDown);
      }
    }
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      var _this$props$view = this.props.view,
          state = _this$props$view.state,
          dispatch = _this$props$view.dispatch;
      var parent = prosemirror_utils_1.findParentNode(function (node) {
        return !!node;
      })(state.selection);

      if (parent) {
        dispatch(state.tr.insertText("", parent.pos, parent.pos + parent.node.textContent.length + 1));
      }
    }
  }, {
    key: "insertBlock",
    value: function insertBlock(item) {
      this.clearSearch();
      var command = this.props.commands[item.name];

      if (command) {
        command(item.attrs);
      } else {
        this.props.commands["create".concat(capitalize_1.default(item.name))](item.attrs);
      }

      this.props.onClose();
    }
  }, {
    key: "calculatePosition",
    value: function calculatePosition(props) {
      var view = props.view;
      var selection = view.state.selection;
      var startPos = view.coordsAtPos(selection.$from.pos);
      var ref = this.menuRef.current;
      var offsetHeight = ref ? ref.offsetHeight : 0;
      var paragraph = view.domAtPos(selection.$from.pos);

      if (!props.isActive || !paragraph.node || !paragraph.node.getBoundingClientRect || SSR) {
        return {
          left: -1000,
          top: 0,
          bottom: undefined,
          isAbove: false
        };
      }

      var _paragraph$node$getBo = paragraph.node.getBoundingClientRect(),
          top = _paragraph$node$getBo.top,
          left = _paragraph$node$getBo.left,
          bottom = _paragraph$node$getBo.bottom;

      var margin = 24;

      if (startPos.top - offsetHeight > margin) {
        return {
          left: left + window.scrollX,
          top: undefined,
          bottom: window.innerHeight - top - window.scrollY,
          isAbove: false
        };
      } else {
        return {
          left: left + window.scrollX,
          top: bottom + window.scrollY,
          bottom: undefined,
          isAbove: true
        };
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          dictionary = _this$props2.dictionary,
          isActive = _this$props2.isActive,
          uploadImage = _this$props2.uploadImage;
      var items = this.filtered;

      var _a = this.state,
          insertItem = _a.insertItem,
          positioning = __rest(_a, ["insertItem"]);

      return React.createElement(react_portal_1.Portal, null, React.createElement(exports.Wrapper, Object.assign({
        id: "block-menu-container",
        active: isActive,
        ref: this.menuRef
      }, positioning), insertItem ? React.createElement(LinkInputWrapper, null, React.createElement(LinkInput, {
        type: "text",
        placeholder: insertItem.title ? dictionary.pasteLinkWithTitle(insertItem.title) : dictionary.pasteLink,
        onKeyDown: this.handleLinkInputKeydown,
        onPaste: this.handleLinkInputPaste,
        autoFocus: true
      })) : React.createElement(List, null, items.map(function (item, index) {
        if (item.name === "separator") {
          return React.createElement(ListItem, {
            key: index
          }, React.createElement("hr", null));
        }

        var selected = index === _this2.state.selectedIndex && isActive;

        if (!item.title || !item.icon) {
          return null;
        }

        return React.createElement(ListItem, {
          key: index
        }, React.createElement(BlockMenuItem_1.default, {
          onClick: function onClick() {
            return _this2.insertItem(item);
          },
          selected: selected,
          icon: item.icon,
          title: item.title,
          shortcut: item.shortcut
        }));
      }), items.length === 0 && React.createElement(ListItem, null, React.createElement(Empty, null, dictionary.noResults))), uploadImage && React.createElement(VisuallyHidden_1.default, null, React.createElement("input", {
        type: "file",
        ref: this.inputRef,
        onChange: this.handleImagePicked,
        accept: "image/*"
      }))));
    }
  }, {
    key: "filtered",
    get: function get() {
      var _this3 = this;

      var _this$props3 = this.props,
          dictionary = _this$props3.dictionary,
          embeds = _this$props3.embeds,
          _this$props3$search = _this$props3.search,
          search = _this$props3$search === void 0 ? "" : _this$props3$search,
          uploadImage = _this$props3.uploadImage;
      var items = block_1.default(dictionary);
      var embedItems = [];

      var _iterator = _createForOfIteratorHelper(embeds),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var embed = _step.value;

          if (embed.title && embed.icon) {
            embedItems.push(Object.assign(Object.assign({}, embed), {
              name: "embed"
            }));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (embedItems.length) {
        items.push({
          name: "separator"
        });
        items = items.concat(embedItems);
      }

      var filtered = items.filter(function (item) {
        var _a;

        if (item.name === "separator") return true;
        if (!uploadImage && item.name === "image") return false;
        if ((_a = _this3.props.disabledItems) === null || _a === void 0 ? void 0 : _a.includes(item.name)) return false;
        var n = search.toLowerCase();
        return (item.title || "").toLowerCase().includes(n) || (item.keywords || "").toLowerCase().includes(n);
      });
      return filtered.reduce(function (acc, item, index) {
        if (item.name === "separator" && index === 0) return acc;
        if (item.name === "separator" && index === filtered.length - 1) return acc;
        var prev = filtered[index - 1];
        if (prev && prev.name === "separator" && item.name === "separator") return acc;
        var next = filtered[index + 1];
        if (next && next.name === "separator" && item.name === "separator") return acc;
        return [].concat(_toConsumableArray(acc), [item]);
      }, []);
    }
  }]);

  return BlockMenu;
}(React.Component);

var LinkInputWrapper = styled_components_1.default.div(_templateObject());
var LinkInput = styled_components_1.default(Input_1.default)(_templateObject2(), function (props) {
  return props.theme.blockToolbarText;
});
var List = styled_components_1.default.ol(_templateObject3());
var ListItem = styled_components_1.default.li(_templateObject4());
var Empty = styled_components_1.default.div(_templateObject5(), function (props) {
  return props.theme.textSecondary;
});
exports.Wrapper = styled_components_1.default.div(_templateObject6(), function (props) {
  return props.theme.text;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.zIndex + 100;
}, function (props) {
  return props.top && "top: ".concat(props.top, "px");
}, function (props) {
  return props.bottom && "bottom: ".concat(props.bottom, "px");
}, function (props) {
  return props.left;
}, function (props) {
  return props.theme.blockToolbarBackground;
}, function (props) {
  return props.theme.blockToolbarDivider;
}, function (_ref) {
  var active = _ref.active,
      isAbove = _ref.isAbove;
  return active && "\n    transform: translateY(".concat(isAbove ? "6px" : "-6px", ") scale(1);\n    pointer-events: all;\n    opacity: 1;\n  ");
});
exports.default = BlockMenu;